import { render } from "./PokemonOptions.vue?vue&type=template&id=0a613a1e&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=0a613a1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a613a1e"

export default script